import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "main",
    "auth",
    "contentManagement",
    "userManagement",
    "productCatalog",
    "companyManagement",
    "failureAnalysisRequest",
    "requestManagement",
    "dashboard",
    "contactManagement",
  ],
};

export default persistConfig;
